import React, { useState, useEffect } from "react";

/** Components */
import { TableContainer, TableHead, TableRow, TableCell, TableBody, Table, Paper, TablePagination, Checkbox, TableFooter, ButtonGroup } from "@mui/material";
import ButtonWithAPICallComponent from "../../commons/ButtonWithAPICall.component";
import SelectStatusButton from "./../../commons/SelectStatusButton";
import LoadingProgress from "../../commons/LoadingProgress.component";

/** Icons */
import RefreshIcon from "@mui/icons-material/Refresh";

/** Api & Function */
import { getProductUnit, postSync, updateProductUnitStatus } from "../../../services/api";
import { setHeaderTitle } from "../../../store/layoutSlide";
/** Package */
import moment from "moment";
import { useTranslation } from "react-i18next";

/** Hook */
import { useDispatch, useSelector } from "react-redux";
import { setDataFromBEState } from "../../../store/dataFromBESlice";

const ProductUnit = () => {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const data = useSelector((state) => state.data.productUnit);
  const [changeIds, setChangeIds] = useState([]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleCheckBoxClick = (id) => {
    if (changeIds.includes(id)) setChangeIds((prev) => prev.filter((item) => item !== id));
    else setChangeIds((prev) => [...prev, id]);
  };
  const handleUpdateStatus = (selectedStatus) => {
    return updateProductUnitStatus({ ids: changeIds, action: selectedStatus.action });
  };
  const handleUpdateStatusResponse = (res, selectedStatus) => {
    if (res.code === 200) {
      let newStatus;
      switch (selectedStatus.action) {
        case 0:
          newStatus = "DEACTIVATED";
          break;
        case 1:
          newStatus = "ACTIVATED";
          break;
        case 4:
          setChangeIds([]);
          newStatus = "DELETED";
          break;
        default:
          break;
      }
      dispatch(setDataFromBEState({ productUnit: data.map((item) => (changeIds.includes(item.id) ? { ...item, status: newStatus } : item)) }));
    }
  };
  useEffect(() => {
    dispatch(setHeaderTitle("THÔNG TIN ĐƠN VỊ TÍNH NHIÊN LIỆU - HÀNG HOÁ"));
    if (!data)
      getProductUnit().then((res) => {
        res.code === 200 && dispatch(setDataFromBEState({ productUnit: res.data }));
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <div align="right" style={{ marginBottom: 10, marginTop: 10, backgroundColor: "#b3deff", height: 40 }}>
        <ButtonGroup style={{ height: 40, marginRight: 10 }}>
          <ButtonWithAPICallComponent title="Cập nhật dữ liệu từ ERP" api={() => postSync({ object: "unit" })} variant="outlined">
            <RefreshIcon />
          </ButtonWithAPICallComponent>
        </ButtonGroup>
      </div>

      {!data ? (
        <LoadingProgress />
      ) : (
        <TableContainer component={Paper} style={{ width: "98%", marginLeft: 10 }} sx={{ maxHeight: 800 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell style={{ border: "0.5px solid lightgray" }}>ID</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Mã")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Tên")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Tên ngắn")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Số lượng cơ sở")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Ngày cập nhật")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Trạng thái")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>
                  <SelectStatusButton disabled={!changeIds.length} api={handleUpdateStatus} response={handleUpdateStatusResponse} />
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).length ? (
                data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => (
                  <TableRow key={row.id}>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.id}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.code} </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.name}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.shortname}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.quantity}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.updated_at && moment(row.updated_at).format("DD/MM/YYYY")}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{t(row.status)}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>
                      <Checkbox disabled={row.status === "DELETED"} checked={changeIds.includes(row.id)} onClick={handleCheckBoxClick.bind(this, row.id)} />
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={50}>{t("Không có dữ liệu")}</TableCell>
                </TableRow>
              )}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[10, 25, 100]}
                  count={data.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      )}
    </div>
  );
};

export default ProductUnit;
